// actions/products.actions.ts
import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store';


import { UserProfile } from 'src/app/shared/models/base.models';






// Current Product Management
export const CurrentProfileActions = createActionGroup({
  source: 'Load Current User Profile',
  events: {
    load: emptyProps(),
    loadSuccess: props<{ profile: UserProfile }>(),
    loadFailure: props<{ error: any }>(),

  },
});



